export default __webpack_public_path__ + "static/media/screenshot2.4b2b1257.jpg";